import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Home.module.css';

function Home() {
    return (
        <div className={styles.jumbotron}>
            <div className={styles.hero_content}>
                <h1 className={styles.main_title}>
                    <span>RBX</span> SCANNER
                </h1>

                <p className={styles.lead_text}>
                    The ultimate defense against malicious Roblox scripts.
                    Detect backdoors, obfuscated code, and vulnerabilities in seconds.
                </p>

                <div className={styles.cta_group}>
                    <Link to="/scanner" className={styles.btn_primary}>
                        LAUNCH SCANNER
                    </Link>
                    <Link to="/updates" className={styles.btn_outline}>
                        VIEW UPDATES
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default Home;